import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const getThemeColor = (theme) => (theme === 'light' ? '4, 10, 29' : '255, 255, 255');

gsap.registerPlugin(ScrollTrigger);

export function initTitleAnimations() {
    const title = document.querySelector('.features-paralax .title');

    if (!title) {
        console.warn('Title animation element not found.');
        return;
    }

    gsap.from(title, {
        opacity: 0,
        y: '3rem',
        scrollTrigger: {
            trigger: title,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
        }
    });
}

export function initPinAndZoomOut() {
    const featuresParalaxSection = document.querySelector('.features-paralax');
    const bottomSection = featuresParalaxSection.querySelector('.features-paralax .bottom-section');

    if (!bottomSection) {
        console.warn('Pin and zoom elements: bottomSection not found.');
        return;
    }

    const imageContainer = bottomSection.querySelector('.image');
    const trigger = featuresParalaxSection.querySelector('.trigger');
    const image1 = imageContainer.querySelectorAll('img.index1');
    const image2 = imageContainer.querySelectorAll('img.index2');

    if (!imageContainer || !image1 || !image2) {
        console.warn('Pin and zoom elements: imageContainer or imageImg not found.');
        return;
    }

    // --- The Pin Animation ---
    ScrollTrigger.create({
        trigger: bottomSection,
        start: 'top top',
        end: '+=2000',
        pin: true
    });

    // --- The Pan and Zoom Animation ---
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top bottom',
        end: 'top+=2000 top',
        scrub: true,
        animation: gsap.timeline()
            .fromTo(imageContainer,
                {
                    width: "191.8em",
                    height: "123.65em",
                    bottom: "-100em"
                },
                {
                    width: "100em",
                    height: "61.9em",
                    bottom: 0
                }, ">"
            )
    });

    // --- The Opacity Animation ---
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top+=1300 top',
        end: '+=200',
        scrub: true,
        onEnter: () => {
            getThemeColor(featuresParalaxSection)
        },
        onEnterBack: () => {
            getThemeColor(featuresParalaxSection)
        },
        animation: gsap.timeline({
            defaults: { duration: 1, ease: "cubic-bezier(.5,-0.53,.14,1.23)" }
        })
            .fromTo(image1, { opacity: 1 }, { opacity: 0 }, 0)
            .fromTo(image2, { opacity: 0 }, { opacity: 1 }, 0)
            .fromTo(bottomSection, { backgroundColor: '#FAFAFA' }, { backgroundColor: '#040A1D' }, 0)
    });


    ScrollTrigger.create({
        trigger: bottomSection,
        start: "bottom top",
        end: "bottom top",
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initTitleAnimations();
    initPinAndZoomOut();
});